import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getServiceAccounts} from "redux/actions/servicesActions";

/**
 * Custom hook to load WhatsApp/Twilio service accounts and
 * initialize whatsappData.
 *
 * @param {string} guestId - The guest ID.
 * @param {function} setWhatsappData - Setter to notify parent about whatsappData changes.
 */
export function useServiceAccounts(setWhatsappData) {
  const dispatch = useDispatch();
  const [hasLoaded, setHasLoaded] = useState(false);

  const serviceAccounts = useSelector(
    (state) => state.defaultReducer.service_accounts,
  );

  useEffect(() => {
    const initAccounts = (accounts = {}) => {
      const waAccs = accounts.whatsapp ?? [];
      const twAccs = accounts.twilio ?? [];
      const account = waAccs[0] || twAccs[0];
      const accountEnabled =
        !!waAccs[0] || twAccs[0]?.properties?.whatsapp_status === "ONLINE";

      if (!accountEnabled) return;

      // if it's from WhatsApp, keep all templates; otherwise only approved
      const templates = (account.properties?.templates ?? []).filter(
        (t) => !!waAccs[0] || t.status === "approved",
      );

      setWhatsappData((prev) => ({
        ...prev,
        accountId: account.service_id,
        templates,
      }));
    };

    const missingData =
      !Object.keys(serviceAccounts?.accounts ?? {}).length ||
      !serviceAccounts.accounts.whatsapp ||
      !serviceAccounts.accounts.twilio;

    if (missingData && !hasLoaded) {
      setHasLoaded(true);
      dispatch(
        getServiceAccounts({
          onSuccess: (res) => {
            initAccounts(res.accounts);
          },
        }),
      );
    } else {
      initAccounts(serviceAccounts.accounts);
    }
  }, [serviceAccounts, hasLoaded]);
}
